import {
  packagePickerCheckoutLoadFailedSrc17Evid728Params,
  packagePickerCycleSelection2ndStepClickContinueToCheckoutSrc17Evid3925Params,
  packagePickerCycleSelectionRevShareLoadedSrc17Evid3927Params,
  premiumPackagePickerCouponToastViewSrc17Evid993Params
} from '@wix/bi-logger-premium-data/v2/types';
import {
  PlanType,
  PaymentCycle,
  SwitchPlanType,
  CurrentPlanInOfferingMode,
  PackagePickerType,
  AppFlow,
} from '../../enums';
import { Omit } from '../../types/global-types';

export enum BiEventIDs {
  ORDER_PAGE_VALIDATION_ERROR = 105,
  ORDER_PAGE_FATAL_ERROR = 177,
  ORDER_PAGE_SUBMIT_PRESSED = 178,
  ORDER_PAGE_BUSINESS_ERROR = 176,
  CHECKOUT_PAGE_VIEW_TOOLTIP = 189,
  PACKAGE_PICKER_LOADED = 940,
  A_PLAN_SELECTED = 3905,
  A_CYCLE_SELECTED = 3906,
  A_PAYMENT_PAGE_READY = 942,
  HOVER_ON_FEATURES = 3910,
  CHANGE_PP_TYPE = 3912,
  TABS_TOOLTIP_CLOSED = 3913,
  PREVIOUS_STEP_SELECT = 3907,
  R_PREMIUM_ORDER_PAGE_SUMBIT_SUCCESS = 3103,
  R_PREMIUM_ORDER_PAGE_SUBMIT_PENDING = 3104,
  R_PREMIUM_ORDER_PAGE_SUBMIT_PENDING_BOLETO = 3202,
  A_VIEW_DOUBLE_PURCHASE_POPUP = 1220,
  A_DOUBLE_PURCHASE_POPUP_VIEW_BUTTON_CLICKED = 1221,
  REQUEST_CALL_POPUP_LOAD = 3914,
  REQUEST_CALL_POPUP_CTA = 3915,
  VIEW_PRODUCT_FEATURE_TOOLTIP = 3910,
  CHANGE_PLAN_POPUP_OPENED = 7900,
  CHANGE_PLAN_POPUP_CLICK_CHANGE = 7901,
  CHANGE_PLAN_POPUP_CLOSED = 7902,
  VIEW_CURRENT_PLAN_MODAL_OPENED = 7503,
  VIEW_CYCLE_DISCOUNT_TOOLTIP = 3916,
  CLICK_ON_FAQ_ITEM = 3917,
  CLICK_ON_SHOW_FEATURES = 3918,
  CLICK_ON_SHOW_ALL_FEATURES = 3919,
  STICKY_HEADER_MOBILE_GRID = 3903,
  SELECT_PLAN_RADIO_BUTTONS_MOBILE_GRID = 3904,
  CLICK_PRODUCT_FEATURE_TOOLTIP_LINK = 3920,
  COMPARE_PLAN_FEATURES_CTA = 3922,
  SUBMIT_CHECKOUT_PLAN_REASSIGN_DOMAIN_FLOW = 997,
  ANONYMOUS_CTA_CLICK = 3923,
}

export enum DayfulBiEventIds {
  PACKAGE_PICKER_LOADED = 840,
  VIEW_CYCLES = 3805,
}

export const EventActionMap = {
  [BiEventIDs.PACKAGE_PICKER_LOADED]: 'A_PremiumPPLoaded',
  [BiEventIDs.A_PLAN_SELECTED]: 'A_PackagePickerEventAddInfoAction',
  [BiEventIDs.A_CYCLE_SELECTED]: 'OnePage PP > Select cycle',
  [BiEventIDs.A_PAYMENT_PAGE_READY]: 'A_PaymentPageReady',
  [BiEventIDs.CHANGE_PP_TYPE]: 'NewDeal > Click change pp type',
  [BiEventIDs.PREVIOUS_STEP_SELECT]: 'OnePage PP > Change',
  [BiEventIDs.ORDER_PAGE_FATAL_ERROR]:
    'R_SbsOrderPagePremiumPurchaseFatalError',
  [BiEventIDs.ORDER_PAGE_SUBMIT_PRESSED]:
    'A_SbsPremiumPurchaseBuyButtonPressed',
  [BiEventIDs.R_PREMIUM_ORDER_PAGE_SUMBIT_SUCCESS]:
    'R_PremiumOrderPageSubmitSuccess',
  [BiEventIDs.ORDER_PAGE_VALIDATION_ERROR]: 'R_PremiumPurchaseError',
  [BiEventIDs.ORDER_PAGE_BUSINESS_ERROR]:
    'R_SbsOrderPagePremiumPurchaseBusinessError',
  [BiEventIDs.VIEW_CYCLE_DISCOUNT_TOOLTIP]: 'Discount tooltip shown',
  [BiEventIDs.CLICK_ON_FAQ_ITEM]: 'package picker > click on question',
  [BiEventIDs.CLICK_ON_SHOW_FEATURES]: 'package picker > Show Feature',
  [BiEventIDs.CLICK_ON_SHOW_ALL_FEATURES]: 'package picker > Show All features',
  [BiEventIDs.CHECKOUT_PAGE_VIEW_TOOLTIP]: 'Checkout Page > view tooltip',
  [BiEventIDs.SUBMIT_CHECKOUT_PLAN_REASSIGN_DOMAIN_FLOW]:
    'submit checkout plan > reassign domain flow',
  [DayfulBiEventIds.PACKAGE_PICKER_LOADED]: 'Dayful package picker > load',
  [DayfulBiEventIds.VIEW_CYCLES]:
    'Dayful package picker > view cycle selection (2nd step)',
};

export enum ContinueEventSteps {
  product = 'product',
  cycle = 'cycle',
  purchasePage = 'purchasePage',
}

export enum PlanTypeClick {
  Top = 'top_clicked',
  Bottom = 'bottom_clicked',
}

export enum FlowType {
  ChangePlan = 'change_plan',
  Upgrade = 'upgrade',
  Regular = 'regular',
}

export type SelectPlanClickSource = 'cards' | 'table';
export type EnterpriseModalClickSource =
  | 'cards'
  | 'table'
  | 'banner'
  | 'faq'
  | undefined;

export const BiStepNames: ContinueEventSteps[] = [
  ContinueEventSteps.product,
  ContinueEventSteps.cycle,
  ContinueEventSteps.purchasePage,
];

export const PaymentCycle_BIMap = {
  [PaymentCycle.MONTHLY]: 3,
  [PaymentCycle.YEARLY]: 6,
  [PaymentCycle.YEAR2]: 7,
  [PaymentCycle.YEAR3]: 8,
  [PaymentCycle.QUARTERLY]: 4,
};

export interface BiEvent {
  evid: BiEventIDs | DayfulBiEventIds;
  action: string;
}

export interface BiEventDefaultParams {
  eventAggregator: string;
  siteGuid: string;
  packagePickerType: PackagePickerType;
  referralAdditionalInfo?: string;
  referer?: string;
  newPurchase?: string;
}

export interface ChangeStepBiEvent extends BiEvent {
  fromStep: string;
  cycle: any;
  productId: number;
  productGuid: string | undefined;
}

export interface PlanTypeInfoBiEvent extends BiEvent {
  ppType: PlanType;
  pricing: BiPlan[];
  clickType: PlanTypeClick;
  currency: string;
}

export interface BiPlan {
  id: string;
  title: string;
  subtitle: string;
  price: number;
  discount: number;
}

export interface AppLoadBiEvent extends BiEvent {
  abTesting: String;
  ppType: PlanType;
  cycle: any;
  productId: number;
  productGuid: string | undefined;
  pricing: BiPlan[];
  currency: string;
  changePlanType: CurrentPlanInOfferingMode;
  currentProductId: number | null;
  intent: string;
  intentDomainName: string | null;
  cartFlow: AppFlow;
}

export interface SelectPlanBiEvent extends BiEvent {
  ppType: PlanType;
  cycle: any;
  productId: number;
  productGuid: string | undefined;
  referralAdditionalInfo: string;
  clickType?: SelectPlanClickSource;
  cartFlow: AppFlow;
}

export interface SelectCycleBiEvent extends BiEvent {
  eventAggregator?: string;
  cycleId?: PaymentCycle;
  cycle: any;
  additionalInfo?: string;
  productId: number;
  productGuid: string | undefined;
  cartFlow?: AppFlow;
}

export interface CheckoutPageLoadedBiEvent extends SelectCycleBiEvent {
  pricing: {
    fullPrice: number;
    priceAfterDiscount: number;
  };
  currency: string;
}

export interface CheckoutPageBiEvent extends BiEvent {
  cycle: number;
  paymentMethod?: number;
  eventAggregator?: string;
  additionalInfo?: string;
  productId: number;
  productGuid: string | undefined;
}

export interface DoublePurchaseBiEvent extends BiEvent {
  productTypeId: string;
  conflictingServiceGuid: string;
  reason: string;
  productGuid: string | undefined;
}

export interface RequestCallCTABiEvent extends BiEvent {
  clickType: 'close' | 'submit';
}

export interface RequestCallPopupLoadBiEvent extends BiEvent {
  ppType: PlanType;
  clickType: EnterpriseModalClickSource;
}

export interface ViewCurrentPlanBiEvent extends BiEvent {
  changePlanType: CurrentPlanInOfferingMode;
  currentProductId: number;
  currentCycleId: number;
  packageId: string;
  flowType: FlowType;
}

export interface ChangePlanBiEvent extends BiEvent {
  changeType: SwitchPlanType;
  productId: number;
  cycle: number;
  newCycle: number;
  newProductId: number;
  packageId: string;
}

export interface ViewProductFeatureTooltipBiEvent extends BiEvent {
  cycle: any;
  productId: number;
  featureKey: string;
  fromStep: 'select_plan' | 'select_cycle' | 'select_purchase_page';
}

export interface ClickProductFeatureTooltipLinkBiEvent extends BiEvent {
  featureKey: string;
  url: string;
}

export interface ViewCycleDiscountTooltip extends BiEvent {
  ppType: PlanType;
  referralAdditionalInfo?: string;
  siteGuid: string;
  eventAggregator?: string;
}

export interface ClickOnFAQItem extends BiEvent {
  questionType: string;
  clickType: string;
  ppType: string;
  siteGuid: string;
}

export interface ClickOnShowFeatures extends BiEvent {
  showFeatureType: string;
  clickType: string;
  ppType: string;
  siteGuid: string;
}

export interface ClickOnShowAllFeatures extends BiEvent {
  clickType: string;
  ppType: string;
  siteGuid: string;
}

export interface CheckoutPageViewTooltip extends BiEvent {
  siteGuid: string;
  tooltipName: string;
}

export interface SelectPlanRadioButtonsMobileGrid extends BiEvent {
  ppType: PlanType;
  productId: number;
  siteGuid: string;
  newPurchase: string;
}

export interface StickyHeaderMobileGrid extends BiEvent {
  ppType: PlanType;
  siteGuid: string;
  newPurchase: string;
}

export interface SubmitCheckoutReassignDomainFlow extends BiEvent {
  msid: string;
  referralAdditionalInfo: string;
  uuid: string;
  domain?: string;
}

export interface AnonymousCtaBiEvent extends BiEvent {
  foldNumber?: number;
  ctaName: string;
  targetUrl: string;
}

export type BiEventParams<T> = Omit<T, keyof BiEvent>;

export interface BiLogger {
  logPlansPageLoadedBiEvent(
    additionalParams: BiEventParams<AppLoadBiEvent>,
  ): void;
  logSubmitPurchaseClickedBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logPurchaseSuccessBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logPurchasePendingBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logSelectCycleBiEvent(
    additionalParams: BiEventParams<SelectCycleBiEvent>,
  ): void;
  logPaymentPageReadyBiEvent(
    additionalParams: BiEventParams<CheckoutPageLoadedBiEvent>,
  ): void;
  logChangeTabBiEvent(
    additionalParams: BiEventParams<PlanTypeInfoBiEvent>,
  ): void;
  logSelectPlanBiEvent(
    additionalParams: BiEventParams<SelectPlanBiEvent>,
  ): void;
  logStepBackBiEvent(additionalParams: BiEventParams<ChangeStepBiEvent>): void;
  logOrderPageValidationErrorBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logOrderPageFatalErrorBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logOrderPageBusinessErrorBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logDoublePurchasePopupViewed(
    additionalParams: BiEventParams<DoublePurchaseBiEvent>,
  ): void;
  logDoublePurchasePopupCTA(): void;
  logTabsTooltipClosed(): void;
  logRequestCallPopupLoad(
    additionalParams: BiEventParams<RequestCallPopupLoadBiEvent>,
  ): void;
  logRequestCallPopupCTA(
    additionalParams: BiEventParams<RequestCallCTABiEvent>,
  ): void;
  logViewProductFeatureTooltip(
    additionalParams: BiEventParams<ViewProductFeatureTooltipBiEvent>,
  ): void;
  logClickLinkInProductFeatureTooltip(
    additionalParams: BiEventParams<ClickProductFeatureTooltipLinkBiEvent>,
  ): void;
  logCurrentPlanModalOpened(
    additionalParams: BiEventParams<ViewCurrentPlanBiEvent>,
  ): void;
  logChangePlanPopupOpened(
    additionalParams: BiEventParams<ChangePlanBiEvent>,
  ): void;
  logChangePlanPopupClickChange(
    additionalParams: BiEventParams<ChangePlanBiEvent>,
  ): void;
  logChangePlanPopupClosed(
    additionalParams: BiEventParams<ChangePlanBiEvent>,
  ): void;
  logDiscountTooltipIsShown(
    additionalParams: BiEventParams<ViewCycleDiscountTooltip>,
  ): void;
  logClickOnFAQItem(additionalParams: BiEventParams<ClickOnFAQItem>): void;
  logClickOnShowFeatures(
    additionalParams: BiEventParams<ClickOnShowFeatures>,
  ): void;
  logClickOnShowAllFeatures(
    additionalParams: BiEventParams<ClickOnShowAllFeatures>,
  ): void;
  logCheckoutPageViewTooltipBiEvent(
    additionalParams: BiEventParams<CheckoutPageViewTooltip>,
  ): void;
  logSelectPlanRadioButtonsMobileGrid(
    additionalParams: BiEventParams<SelectPlanRadioButtonsMobileGrid>,
  ): void;
  logStickyHeaderMobileGrid(
    additionalParams: BiEventParams<StickyHeaderMobileGrid>,
  ): void;
  logDayfulPlansPageLoadedBiEvent(
    additionalParams: BiEventParams<AppLoadBiEvent>,
  ): void;
  logDayfulCyclesPageViewBiEvent(
    additionalParams: BiEventParams<SelectPlanBiEvent>,
  ): void;
  logComparePlanFeaturesCTA(additionalParams: BiEventParams<BiEvent>): void;
  logSubmitCheckoutReassignDomainFlow(
    additionalParams: BiEventParams<SubmitCheckoutReassignDomainFlow>,
  ): void;
  logAnonymousCtaClick(
    additionalInfo: BiEventParams<AnonymousCtaBiEvent>,
  ): void;
  logContinueToCheckout(
    additionalInfo: packagePickerCycleSelection2ndStepClickContinueToCheckoutSrc17Evid3925Params,
  ): void;
  logCheckoutLoadFailed(
    additionalInfo: packagePickerCheckoutLoadFailedSrc17Evid728Params,
  ): void;
  logIsRevShareVisible(
    additionalInfo: packagePickerCycleSelectionRevShareLoadedSrc17Evid3927Params,
  ): void;
  logCouponToastView(
    additionalInfo: premiumPackagePickerCouponToastViewSrc17Evid993Params,
  ): void
}
